import {Resource} from '@raison/types';
import {BalancesSchema} from './balancesTypes';

export const selectBalancesResource = (state: AppModel): Resource<BalancesSchema> => {
    return state.balances;
};
